import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Composer from "@/pages/Composer";
import Queue from "@/pages/Queue";
import Groups from "@/pages/Groups";
import History from "@/pages/History";
import Settings from "@/pages/Settings";
import CalendarPage from "@/pages/CalendarPage";
import Templates from "@/pages/Templates";
import FbDone from "@/pages/FbDone";
import FastPost from "@/pages/FastPost";
import GroupCheck from "@/pages/GroupCheck";
import Autopilot from "@/pages/Autopilot";
import Gallery from "@/pages/Gallery";
import { announceToHelper } from "@/lib/helper";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  useEffect(() => { announceToHelper(); }, []);
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/fb-selesai" element={<FbDone />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="tulis" element={<Composer />} />
              <Route path="jadual" element={<Queue />} />
              <Route path="post-pantas" element={<FastPost />} />
              <Route path="kalendar" element={<CalendarPage />} />
              <Route path="template" element={<Templates />} />
              <Route path="galeri" element={<Gallery />} />
              <Route path="kumpulan" element={<Groups />} />
              <Route path="kumpulan/semak" element={<GroupCheck />} />
              <Route path="sejarah" element={<History />} />
              <Route path="tetapan" element={<Settings />} />
              <Route path="autopilot" element={<Autopilot />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}

export default App;
